import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

const EMPTY_DISTRIBUTION = { items: [], overallMedian: 0 };

export const useCaseContentDistribution = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange } = filterParams;
    const { getData } = useAxios();

    const [treatmentDateCount, setTreatmentDateCount] = useState(EMPTY_DISTRIBUTION);
    const [treatmentDateTextLength, setTreatmentDateTextLength] = useState(EMPTY_DISTRIBUTION);
    const [lifecarePlanLength, setLifecarePlanLength] = useState(EMPTY_DISTRIBUTION);
    const [selectedDistribution, setSelectedDistribution] = useState(null);
    const [isContentDistributionOpen, setIsContentDistributionOpen] = useState(false);

    useEffect(() => {
        const fetchContentDistribution = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange });

            try {
                const response = await getData(`${baseUrl.caseContentDistribution}?${query}`);
                if (response?.success) {
                    setTreatmentDateCount(response?.data?.treatmentDateCount || EMPTY_DISTRIBUTION);
                    setTreatmentDateTextLength(response?.data?.treatmentDateTextLength || EMPTY_DISTRIBUTION);
                    setLifecarePlanLength(response?.data?.lifecarePlanLength || EMPTY_DISTRIBUTION);
                }
            } catch (err) {
                console.error("Failed to fetch case content distribution", err);
                setTreatmentDateCount(EMPTY_DISTRIBUTION);
                setTreatmentDateTextLength(EMPTY_DISTRIBUTION);
                setLifecarePlanLength(EMPTY_DISTRIBUTION);
            }
        };

        fetchContentDistribution();
    }, [selectedRange]);

    const onOpenContentDistribution = ({ row, metricLabel }) => {
        setSelectedDistribution({ ...row, metricLabel });
        setIsContentDistributionOpen(true);
    };

    const closeContentDistribution = () => {
        setIsContentDistributionOpen(false);
    };

    return {
        treatmentDateCountDistribution: treatmentDateCount.items,
        treatmentDateTextLengthDistribution: treatmentDateTextLength.items,
        lifecarePlanLengthDistribution: lifecarePlanLength.items,
        selectedDistribution,
        isContentDistributionOpen,
        onOpenContentDistribution,
        closeContentDistribution
    };
};
